import React, { ReactElement } from "react";

import { IconChat } from "../icons/IconChat";
import { agentMessageContentCSS } from "./AgentMessage.styles";
import { ChatResponseProps } from "./AgentMessage.types";

export const AgentMessage = ({
  children,
  ...rest
}: ChatResponseProps): ReactElement => {
  return (
    <div {...rest} style={{ display: "flex", width: "90%" }}>
      <div style={{ marginRight: 16, marginTop: 2 }}>
        <IconChat style={{ width: 16, height: 16 }} data-testid="icon-chat" />
      </div>
      <div className={agentMessageContentCSS}>{children}</div>
    </div>
  );
};
